import { RootState } from '@iwProvider/configureStore';
import { H2 } from '@ui';
import { connect } from 'react-redux';

import { EditDebitCardForm } from './EditDebitCardForm';
import LinkBankAccountForm from '../addPaymentMethodModal/linkBankAccount/LinkBankAccountForm';

const mapStateToProps = (state: RootState) => ({
    paymentMethodType: state.editPaymentMethodModal.type
});

function EditPaymentMethodModal({
    paymentMethodType
}: ReturnType<typeof mapStateToProps>) {
    if (paymentMethodType === 'bank_account') {
        return (
            <div>
                <H2 className="mb-l">Update your bank account</H2>
                <LinkBankAccountForm />
            </div>
        );
    }

    return <EditDebitCardForm />;
}

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(EditPaymentMethodModal);
